import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
} from "@angular/core";
import { HouseOrderGuestService } from "./house-order-guest.service";
import _ from "lodash";
import { TranslateService } from "@root/shared/service/translate.service";
import { takeUntil, tap } from "rxjs";
import { Subject } from "rxjs";
// import { CREDENTIAL_TYPE } from '@root/config';
import { NzModalService } from "ng-zorro-antd/modal";
import { NzContextMenuService, NzDropdownMenuComponent } from "ng-zorro-antd/dropdown";
import { listOfHeaderForGuestList } from "@root/router/guest-list/guest-list.props";
import { ViewVoucherComponent } from "@root/component/view-voucher/view-voucher.component";
import { PAGES_NAME, SwitchPageService } from "@root/router/component/order-detail-sidebar/switch-page.service";
import { ModalService } from "@root/router/index/modal.service";
import { NzDrawerRef, NzDrawerService } from "ng-zorro-antd/drawer";
import { OrderGuestDetailComponent } from "./order-guest-detail/order-guest-detail.component";
import { OrderGuestSimilarComponent } from "./order-guest-similar/order-guest-similar.component";
import { MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";

@Component({
  selector: "host-house-order-guest",
  templateUrl: "./house-order-guest.component.html",
  styleUrls: ["./house-order-guest.component.scss"],
})
export class HouseOrderGuestComponent implements OnInit, OnChanges, OnDestroy {
  @Input() code: string = null;
  @Input() pageType: "sidebar" | "modal" = "sidebar";
  @Output() refreshModal = new EventEmitter();

  listOfGuest = [];
  total = 0;
  page = 1;
  pageSize = 50;
  checkedGuest = null;

  loading = false;
  listOfHeader = listOfHeaderForGuestList;
  countryList = [];

  private destroy$ = new Subject();

  constructor(
    private guestService: HouseOrderGuestService,
    private t: TranslateService,
    private contextMenuService: NzContextMenuService,
    private modalService: NzModalService,
    private calendarService: MultiHouseCalendarService,
    private localModalService: ModalService,
    private drawer: NzDrawerService,
    private cdr: ChangeDetectorRef,
    @Optional() private drawerRef: NzDrawerRef,
  ) {}

  ngOnInit() {
    if (this.pageType !== "sidebar") {
      this.getCountryList();
      // this.fetchGuestList();
    }
    // this.currentOrderPageRaw$.pipe(takeUntil(this.destroy$)).subscribe();
    this.guestService.orderGuestListRefreshRaw$.pipe(takeUntil(this.destroy$)).subscribe((message) => {
      if (_.get(message, "refresh")) {
        this.code = _.get(message, "code");
        this.fetchGuestList();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["code"] && changes["code"].currentValue) {
      this.fetchGuestList();
      // this.getPageAndDataForJump();
    }
  }

  getCountryList() {
    this.guestService.getCountryList().subscribe((res) => {
      if (res.error_code === 0) {
        this.countryList = _.get(res, "data");
      }
    });
  }

  fetchGuestList() {
    const params = {
      page: this.page,
      page_size: this.pageSize,
      reservation_code: this.code,
    };

    this.loading = true;
    this.guestService.getGuestList(params).subscribe((res) => {
      this.loading = false;
      if (res.error_code === 0) {
        this.guestService.updateOrderGuestListRefresh({
          refresh: false,
          code: null,
        });
        this.listOfGuest = res?.data?.list ?? [];

        /**
         * @todo
         * @compact
         */
        this.cdr.markForCheck();
      }
    });
  }

  checkGuestDetail(guest) {
    this.drawer.create({
      nzTitle: guest.name,
      nzContent: OrderGuestDetailComponent,
      nzWidth: 520,
      nzMask: false,
      nzMaskClosable: false,
      nzContentParams: {
        guestId: guest.id,
      },
    });
  }

  onPageChange() {
    this.fetchGuestList();
  }

  onContextMenu(event, menu: NzDropdownMenuComponent) {
    this.contextMenuService.create(event, menu);
  }

  deleteGuest(id) {
    this.modalService.warning({
      // nzTitle: "即将从入住单中移除此房客，但房客数据依然保留，确定移除吗？",
      nzTitle: this.t.syncGet("warning.remove_guest_info"),
      nzCancelText: this.t.syncGet("word.cancel"),
      nzOkText: this.t.syncGet("word.confirm"),
      nzOnOk: () => this.queryDelete(id),
    });
  }

  queryDelete(id) {
    this.guestService
      .deleteGuest({
        client_id: id,
        reservation_code: this.code,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.fetchGuestList();
          const refresh = true;
          this.refreshModal.emit(refresh);
          if (this.pageType === "sidebar") {
            this.calendarService.refresh();
          }
        }
      });
  }

  showCredentials(data) {
    if (data.length === 0) {
      return;
    }
    const list = [];
    _.forEach(data, (info) => {
      list.push({
        url: _.get(info, "urls.large_url"),
      });
    });
    this.modalService.create({
      nzTitle: this.t.syncGet("word.credentials"),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        pictureList: list,
      },
    });
  }

  closePannel() {
    this.calendarService.cancelSelectReservation();

    this.drawerRef?.close();
    // this.switchPageService.destroyCurrentLianBiao();
  }

  addGuest() {
    const duplicateGuestModal = this.localModalService.displayDuplicateGuestModal();
    duplicateGuestModal.afterClose.subscribe((res) => {
      if (res && res.type === "onClickCreateGuest") {
        const createGuestModal = this.localModalService.displayCreateGuestModal(res.data);
        // 添加一个新的房客
        createGuestModal.afterClose.subscribe((message) => {
          if (message && message.type === "onSuccess") {
            this.relateGuestToOrder(message.data.id);
          }
        });
      }
      if (res && res.type === "onClickExistGuest") {
        // 需要将data绑定到入住单上
        this.relateGuestToOrder(res.data.id);
      }
    });
  }

  relateGuestToOrder(id) {
    const params = {
      client_id: id,
      reservation_code: this.code,
    };
    this.guestService.addGuestToReservation(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.fetchGuestList();
        const refresh = true;
        this.refreshModal.emit(refresh);
      }
    });
  }

  // getCountryName(country) {
  //   let notFind = true;
  //   let item;
  //   for (let i = 0; i < this.countryList.length && notFind; i++) {
  //     item = _.find(_.get(this.countryList[i], "members"), { alpha2: country });
  //     if (item) {
  //       notFind = false;
  //     }
  //   }
  //   return item ? item.name : "-";
  // }

  editGuest(guest) {
    _.assign(guest, {
      id_type: _.get(guest, "id_type") === "" ? null : _.get(guest, "id_type"),
    });
    const modal = this.localModalService.displayUpdateGuestModal(guest);
    modal.afterClose.subscribe((res) => {
      if (res && res.type === "onSuccess") {
        const refresh = true;
        this.refreshModal.emit(refresh);
        this.fetchGuestList();
        if (this.pageType === "sidebar") {
          this.calendarService.refresh();
        }
      }
    });
  }

  checkSimilarGuest(id) {
    const ref = this.drawer.create({
      nzTitle: this.t.t("order.similar_guest"),
      nzContent: OrderGuestSimilarComponent,
      nzWidth: 520,
      nzMask: false,
      nzMaskClosable: false,
      nzContentParams: {
        guestId: id,
      },
    });
    ref.afterClose.subscribe(() => {
      this.fetchGuestList();
    });
    // this.switchPageService.navigate(PageName.GuestSimilar, { id });
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
